import { ViewerGroupInterface } from '../../models';
import { CustomizationParams } from '../customizations';
import { instanceOfViewerGroupAttribute } from '../viewer-options';

export const openAttributesOnLoad = (customizationParams: CustomizationParams | null, groups: ViewerGroupInterface[]) => {
  const attributesIds: string[] = [];
  const openAttributesParams = customizationParams?.openAttributesOnLoad;

  if (openAttributesParams) {
    groups.forEach((grp) => {
      if (instanceOfViewerGroupAttribute(grp)) {
        if (openAttributesParams.includes('all')) {
          attributesIds.push(...grp.attributes.map((attr) => attr.id));
        } else {
          grp.attributes.forEach((attr) => {
            if (openAttributesParams.includes(attr.id)) {
              attributesIds.push(attr.id);
            }
          });
        }
      }
    });
  }
  const setAttributesIds = new Set(attributesIds);
  if (attributesIds.length) return Array.from(setAttributesIds);

  return null;
};
